import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCaretDown } from "@fortawesome/free-solid-svg-icons";

const CategoryList = ({ categories, selectedCategory, onCategorySelect }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleCategorySelect = (category) => {
    onCategorySelect(category);
    setIsDrawerOpen(false); // Close drawer on selection
  };

  return (
    <div className="h-full overflow-y-auto">
      {/* Button for mobile view */}
      <div className="block md:hidden">
        <button
          onClick={() => setIsDrawerOpen(true)}
          className="py-1 px-3 border border-gray-300 rounded-lg bg-white flex gap-2 items-center float-right"
        >
          Select Menu{" "}
          <FontAwesomeIcon
            icon={faCaretDown}
            style={{
              color: "#000000",
            }}
          />
        </button>

        {/* Overlay (Mask) */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-45 transition-opacity ${
            isDrawerOpen ? "opacity-100 visible z-40" : "opacity-0 invisible"
          }`}
          onClick={() => setIsDrawerOpen(false)}
        />

        {/* Drawer */}
        <div
          className={`fixed bottom-0 left-0 w-full bg-white rounded-t-[30px] pt-6 p-4 transition-transform duration-300 z-50 box-shadow: 0 -6px 16px 0 rgba(0, 0, 0, 0.08), 0 -3px 6px -4px rgba(0, 0, 0, 0.12), 0 -9px 28px 8px rgba(0, 0, 0, 0.05); ${
            isDrawerOpen ? "translate-y-0" : "translate-y-full"
          }`}
        >
          <h2 className="flex justify-between items-center pb-8 p-2 text-base mt-2 mb-2">
            Select Category{" "}
            <button onClick={() => setIsDrawerOpen(false)}>
              <FontAwesomeIcon
                icon={faTimes}
                className="border border-gray-300 rounded-full p-2 px-3"
                style={{
                  color: "#000000",
                }}
              />
            </button>
          </h2>
          {categories.length > 0 ? (
            <ul className="flex flex-wrap gap-2 pb-8">
              {categories &&categories.map((category, index) => (
                <li
                  key={index}
                  onClick={() => handleCategorySelect(category)}
                  // className="cursor-pointer py-2 px-4 text-left border-[0.5px] border-black rounded-full"
                  className={`cursor-pointer py-2 px-4 text-left border-[0.5px] border-black-100 rounded-full ${
                    selectedCategory?.name === category.name
                      ? "border-0 bg-green-100 text-green-900"
                      : "bg-white text-gray-700"
                  } hover:bg-green-100`}
                >
                  {category.name}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500 text-center">No categories available</p>
          )}
        </div>
      </div>

      {/* List for desktop view */}
      {categories.length > 0 ? (
        <ul className="hidden md:flex flex-col">
          {categories &&categories.map((category, index) => (
            <li
              key={index}
              onClick={() => onCategorySelect(category)}
              className={`cursor-pointer py-1 px-4 mb-2 text-left font-medium border border-gray-300 rounded ${
                selectedCategory?.name === category.name
                  ? "border-green-500 bg-green-100"
                  : "bg-white text-gray-700"
              } hover:bg-green-100`}
            >
              {category.name}
            </li>
          ))}
        </ul>
      ) : (
        <p className="hidden md:block text-gray-500 text-center">
          No categories available
        </p>
      )}
    </div>
  );
};

export default CategoryList;